<template>
    <v-container :fluid="true">
        <h1>Registro de carnets Alcaldia San Salvador Sur</h1>
        <v-divider></v-divider>
        <v-btn color="success" @click="accionesDialogo(1)" prepend-icon="mdi-card-account-details">Agregar</v-btn>
        <v-divider></v-divider>
        <h2>Filtro</h2>
        <v-text-field
            v-model="filtro"
            label="Buscar"
            prepend-inner-icon="mdi-magnify"
            variant="outlined"
            hide-details
            single-line
        ></v-text-field>
        <v-divider></v-divider>
        <v-card>
            <v-card-text>
                <v-data-table :headers="headers" :items="datos" class="custom-header" :search="filtro">
                    <template #[`item.url_foto`]="{item}">
                        <v-avatar :image="item.url_foto" size="60"></v-avatar>
                    </template>
                    <template #[`item.actions`]="{item}">
                        <v-btn icon="mdi mdi-image-edit" @click="accionesTabla(1,item)">
                            <v-icon>mdi mdi-image-edit</v-icon>
                            <v-tooltip
                                activator="parent"
                                location="top"
                            >Cambiar imagen</v-tooltip>
                        </v-btn>
                        <v-btn icon="mdi mdi-book-edit" @click="accionesTabla(2,item)">
                            <v-icon>mdi mdi-book-edit</v-icon>
                            <v-tooltip
                                activator="parent"
                                location="top"
                            >Editar datos</v-tooltip>
                        </v-btn>
                        <!-- Boton para previsualizar el carnet -->
                        <v-btn icon="mdi mdi-badge-account" @click="accionesTabla(3,item)">
                            <v-icon>mdi mdi-badge-account</v-icon>
                            <v-tooltip
                                activator="parent"
                                location="top"
                            >Ver carnet</v-tooltip>
                        </v-btn>
                    </template>
                    <template #[`item.estado`]="{item}">
                        <h3 v-if="item.fk_estado===1" style="color: green;">{{ item.estado }}</h3>
                        <h3 v-else style="color: red;">{{ item.estado }}</h3>
                    </template>
                    <template #no-data>
                        <div class="text-center">
                            <p>No hay carnets</p>
                        </div>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-container>
    <!-- formulario -->
<v-dialog v-model="dialogoForm" width="500">
    <v-card>
        <v-card-text>
            <h4>Registro de empleado</h4>
            <v-divider></v-divider>
            <v-form ref="form">
                <v-text-field
                    :rules="[validarCodigo]"
                    title="Codigo"
                    label="Codigo"
                    clearable
                    v-model="objeto.codigo"
                ></v-text-field>
                <v-text-field
                    :rules="[validarDui]"
                    title="DUI"
                    label="DUI"
                    clearable
                    v-model="objeto.dui"
                ></v-text-field>
                <v-text-field
                    :rules="[validarTexto]"
                    title="Nombre"
                    label="Primer nombre"
                    clearable
                    v-model="objeto.nombres"
                ></v-text-field>
                <v-text-field
                    :rules="[validarTexto]"
                    title="Apellidos"
                    label="Primer apellido"
                    clearable
                    v-model="objeto.apellidos"
                ></v-text-field>
                <v-text-field
                    :rules="[validarTexto]"
                    title="Cargo"
                    label="Cargo"
                    clearable
                    v-model="objeto.cargo"
                ></v-text-field>
                <v-text-field
                    :rules="[validarTexto]"
                    title="Area"
                    label="Area"
                    clearable
                    v-model="objeto.area"
                ></v-text-field>
                <v-select
                    :rules="[validarSelects]"
                    :items="estado"
                    item-title="estado"
                    item-value="id"
                    label="Estado"
                    key="id"
                    clearable
                    v-model="objeto.fk_estado"
                ></v-select>
                <!-- <v-select
                    :rules="[validarSelects]"
                    :items="distritos"
                    label="Distritos"
                    item-title="distrito"
                    item-value="id"
                    clearable
                    v-model="objeto.fk_distrito"
                ></v-select> -->
            </v-form>
            
            <v-divider></v-divider>
            <div>
                <v-btn v-if="btnEditar" style="margin-left: 10px;" color="warning" @click="actualizar">Editar</v-btn>
                <v-btn v-if="btnAgregar" style="margin-left: 10px;" color="success" @click="agregar">Guardar</v-btn>
                <v-btn style="margin-left: 10px;" color="secondary" @click="dialogoForm=false">Cerrar</v-btn>
            </div>
        </v-card-text>
    </v-card>
</v-dialog>
<!-- Fotografias -->
<v-dialog v-model="dialogoDetalles" width="80%" min-height="90vh" persistent>
    <v-card min-height="60%">
        <v-card-text>
            <ImgCutter @cargando="cargando=true" @cargandoError="cargando=false" @finalizado="accionesDialogo(5)" :item="objeto"/>
        </v-card-text>
        <div style="margin: 20px;">
            <v-btn :disabled="cargando" color="secondary" @click="dialogoDetalles=false">Cerrar</v-btn>
        </div>
    </v-card>
</v-dialog>
<!-- Alertas -->
<v-dialog>
    <v-card>
        <v-card-text>
            
        </v-card-text>
    </v-card>
</v-dialog>
<!-- Carnet -->
 <v-dialog v-model="dialogoCarnet" max-width="60vw">
    <v-card>
        <v-card-text>
            <h2>Previsualizacion de carnet</h2>
            <v-divider></v-divider>
            <!-- primera version del carnet -->
            <!-- <Carnet :item="objeto" :logoFrente="require('../assets/logosurblue.png')"  />  -->
            <!-- Segunda version del carnet -->
            <CarnetRev2 :item="objeto" :logoFrente="require('../assets/logo_white_nl.png')" :logo-trasero="require('../assets/logo_white.png')" />
        </v-card-text>
    </v-card>
 </v-dialog>
</template>
<v-snackbar v-model="alerta" color="success" :timeout="1600"> {{ alertaMsg }}</v-snackbar>
<script>
import Swal from 'sweetalert2';
//import Carnet from '@/components/carnet.vue';//primera version de carnet
import ImgCutter from '@/components/ImgCutter.vue';
import axios from 'axios';
import CarnetRev2 from '@/components/carnetRev2.vue';


export default {
    name:'CarnetView',
    components:{
        ImgCutter,
        //Carnet,//primera version del carnet
        CarnetRev2
    },
    data(){
        return{
            //dbData
            url:'http://127.0.0.1:8000/api/carnets',
            urlDistrito:'http://127.0.0.1:8000/api/distritos',
            urlEstado:'http://127.0.0.1:8000/api/estados',
            pwdkey:'3JAmksLh0YeObnNM',
            config:{
                headers:{
                    'Authorization':'Bearer '+this.$store.getters.getToken
                }
            },
            //autentificacion para metodos get
            params:{
                'params':{
                    pwd:'3JAmksLh0YeObnNM'
                }
            },
            //tabla
            filtro:'',
            datos:[],
            headers:[
                {title:'Foto',value:'url_foto'},
                {title:'DUI',value:'dui'},
                {title:'Nombres',value:'nombres'},
                {title:'Apellidos',value:'apellidos'},
                {title:'Cargo',value:'cargo'},
                {title:'Estado',value:'estado'},
                {title:'Area',value:'area'},
                {title:'Acciones',value:'actions'}
            ],
            //para las imagenes
            imgUrl:null,
            //variables db
            objeto:{},
            estado:[{id:'1',estado:'activo'},{id:'2',estado:'inactivo'}],
            distritos:[],
            unidades:[],
            //ux interaccion
            dialogoForm:false,
            dialogoDetalles:false,
            dialogoCarnet:false,
            //botones
            btnAgregar:true,
            btnEditar:false,
            //alertas
            //nackbar
            alerta:false,
            alertaMsg:'Revise los campos',
            //validaciones
            //eventos 
            cargando:false,
            
        }
    },
    methods:{
        obtenerDominio(){
            this.url = `${this.$store.state.dominio}/carnets`
            this.urlDistrito = `${this.$store.state.dominio}/distritos`
            this.urlEstado = `${this.$store.state.dominio}/estados`
        },
        //alertas
        success(msg){
            Swal.fire({
            position: "top-end",
            icon: "success",
            title: msg,
            showConfirmButton: false,
            timer: 1500
            });
        },
        danger(msg){
            Swal.fire({
            position: "center",
            icon: "error",
            title: msg,
            showConfirmButton: false,
            timer: 1500
            });
        },
        //tablas externas
        obtenerDistritos(){
            axios.get(this.urlDistrito,this.params,this.config)
            .then(response=>{
                if(response.data.code ==200){
                    this.distritos = response.data.data;
                }
            })
            .catch(error=>{
                console.log("Error: ",error)
            })
        },
        obtenerEstados(){
            axios.get(this.urlEstado,this.params,this.config)
            .then(response=>{
                if(response.data.code ==200){
                    this.estado = response.data.data;
                }
            })
            .catch(error=>{
                console.log("Error: ",error)
            })
        },
        //recarga deimagen
        reloadImg(id){
            axios.get(`${this.url}/${id}`,this.params)
            .then(response=>{
                if(response.data.code ==200){
                    this.imgUrl = response.data.data.url_foto;
                }
            })
            .catch(error=>{
                console.log('Error: ',error);
            })
        },
        //funciones para db
        obtener(){
            axios.get(this.url,this.params,this.config)
            .then(response=>{
                if(response.data.code ==200){
                    this.datos = response.data.data;
                }
            })
            .catch(error=>{
                console.log("Error: ",error)
            })
        },
        agregar(){
            if(!this.$refs.form.validate()){
                return
            }
            //validar el ingreso de datos
            this.objeto.pwdkey = this.pwdkey;
            this.objeto.fk_distrito = '1'
            axios.post(this.url,this.objeto,this.config)
            .then(response=>{
                if(response.data.code ==200){
                    this.datos = [];
                    this.obtener();
                    this.objeto = response.data.data;
                    this.agregarQr(this.objeto);
                }
            })
            .catch(error=>{
                console.log("Error: ",error)
            })
        },
        agregarQr(item){

            let llave = this.generarLlaveAleatoria()
            let dominio = `${this.$store.state.dominio}/info/${item.id}${llave}`;

            console.log(dominio);

            let qr = `https://quickchart.io/qr?text=`;
            item.url_qr = `${qr}${dominio}`;

            console.log(item.url_qr);

            item.llave = llave;
            item.pwdkey = this.pwdkey;

            axios.put(`${this.url}/${item.id}`,item,this.config)
            .then(response=>{
                if(response.data.code == 200){
                    console.log('se genero un qr');
                    this.accionesDialogo(4);
                }
            })
            .catch(error=>{
                console.log("error: ",error)
            })
        },
        actualizar(){
            this.objeto.pwdkey = this.pwdkey;
            axios.put(`${this.url}/${this.objeto.id}`,this.objeto,this.config)
            .then(response=>{
                if(response.data.code == 200){
                    this.dialogoForm = false;
                    this.obtener();
                    this.success('Actualizado con exito!');
                }
            })
            .catch(error=>{
                console.log("error: ",error)
            })
        },
        //genera la llave de acceso
        generarLlaveAleatoria() {
            const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let llave = '';
            for (let i = 0; i < 6; i++) {
                const indiceAleatorio = Math.floor(Math.random() * caracteres.length);
                llave += caracteres[indiceAleatorio];
            }
            return llave;
        },
        //ux interacciones
        accionesTabla(accion,item){
            switch(accion){
                //accion oara ver la info
                case 1:
                    this.objeto = item;
                    this.reloadImg(item.id);
                    this.dialogoDetalles = true;
                    break;
                case 2:
                    this.objeto = item;
                    this.accionesDialogo(accion);
                    break;
                case 3:
                    this.objeto = item;
                    this.reloadImg(item.id);
                    this.accionesDialogo(accion);
                    break;
                case 4:
                    this.dialogoDetalles = true;
                    this.dialogoForm = false;
                    break;
            }
        },
        accionesDialogo(accion){
            switch(accion){
                //para crear un nuevo registro
                case 1:
                    this.objeto = {};
                    this.dialogoForm = true;
                    this.btnAgregar=true;
                    this.btnEditar = false; 
                    break;
                //para editar informacion
                case 2:
                    this.dialogoForm = true;
                    this.btnAgregar = false;
                    this.btnEditar = true;
                    break;
                    //abre el preview del carnet
                case 3:
                    this.dialogoCarnet = true;
                    break;
                    //cuando se guarda un registro lo lleva al cuadro de dialogo de imagenes
                case 4:
                    this.dialogoDetalles = true;
                    this.dialogoForm = false;
                    break;
                //cuando se guarda la imagen cierra el dialogo
                case 5:
                    this.dialogoDetalles = false;
                    this.datos = [];
                    this.obtener();
                    this.success('Agregado con exito!');
                    break;
            }
        },
        //validacion de campos
        validarDui(value){
            const regex = /^[0-9]{8}-[0-9]$/;
            return regex.test(value) || 'Formato de DUI incorrecto';
        },
        validarCodigo(value){
            const regex = /^[0-9]{4}$/;
            return regex.test(value) || 'Formato de codigo incorrecto';
        },
        validarTexto(value){
            const regex = /^[A-Z].+/;
            return regex.test(value) || 'El campo debe empezar en mayusculas';
        },
        validarSelects(value){
            const regex = /^[1-9]/;
            return regex.test(value) || 'Debe seleccionar una opción';
        },
        //cargar imagen
        cargarImg(event){
            this.fileImg = event.target.files[0];
            console.log(this.fileImg);
        },
    },
    created(){
        this.obtenerDominio();
        this.obtenerDistritos();
        this.obtenerEstados();
        this.obtener();
    }
}
</script>
<style scoped>
    .v-divider{
        margin: 10px 0px 10px 0px;
    }
</style>